/**
 * Analytics utility functions
 * Supports Google Analytics and custom analytics
 */

/**
 * Initialize Google Analytics
 * @param {string} trackingId - Google Analytics tracking ID
 */
export const initGA = (trackingId) => {
  if (!trackingId || typeof window === 'undefined') return;

  // Load Google Analytics script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  document.head.appendChild(script1);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer.push(args);
  }
  gtag('js', new Date());
  gtag('config', trackingId);

  window.gtag = gtag;
};

/**
 * Track page view
 * @param {string} path - Page path
 * @param {string} title - Page title
 */
export const trackPageView = (path, title) => {
  if (typeof window === 'undefined') return;

  // Google Analytics
  if (window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_TRACKING_ID, {
      page_path: path,
      page_title: title,
    });
  }

  // Custom analytics (if needed)
  if (window.analytics && typeof window.analytics.track === 'function') {
    window.analytics.track('Page Viewed', {
      path,
      title,
    });
  }
};

/**
 * Track custom event
 * @param {string} eventName - Event name
 * @param {Object} eventData - Event data
 */
export const trackEvent = (eventName, eventData = {}) => {
  if (typeof window === 'undefined') return;

  // Google Analytics
  if (window.gtag) {
    window.gtag('event', eventName, eventData);
  }

  // Custom analytics
  if (window.analytics && typeof window.analytics.track === 'function') {
    window.analytics.track(eventName, eventData);
  }
};

/**
 * Track button click
 * @param {string} buttonName - Button name/identifier
 * @param {string} location - Location context
 */
export const trackButtonClick = (buttonName, location = 'unknown') => {
  trackEvent('button_click', {
    button_name: buttonName,
    location,
  });
};

/**
 * Track link click
 * @param {string} linkUrl - Link URL
 * @param {string} linkText - Link text
 */
export const trackLinkClick = (linkUrl, linkText) => {
  trackEvent('link_click', {
    link_url: linkUrl,
    link_text: linkText,
  });
};

